/**
 * Button — shadcn Button 어댑터
 *
 * 기존 @/ui Button API(variant primary/secondary/danger/ghost/outline,
 * size sm/md/lg, loading)를 유지하며 내부는 shadcn Button으로 위임한다.
 */
import { ButtonHTMLAttributes } from 'react'
import { Button as ShadButton } from '@/components/ui/button'
import { Spinner } from './Spinner'

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'danger' | 'ghost' | 'outline'
  size?: 'sm' | 'md' | 'lg'
  loading?: boolean
}

const VARIANT_MAP = {
  primary: 'default',
  secondary: 'secondary',
  danger: 'destructive',
  ghost: 'ghost',
  outline: 'outline',
} as const

const SIZE_MAP = {
  sm: 'sm',
  md: 'default',
  lg: 'lg',
} as const

export function Button({
  variant = 'primary',
  size = 'md',
  loading = false,
  disabled = false,
  children,
  className,
  ...props
}: ButtonProps) {
  return (
    <ShadButton
      variant={VARIANT_MAP[variant]}
      size={SIZE_MAP[size]}
      disabled={disabled || loading}
      className={className}
      {...props}
    >
      {loading && <Spinner size="sm" />}
      {children}
    </ShadButton>
  )
}
